import { createRoot } from 'react-dom/client'
import ReactGA from 'react-ga4'
import { ParallaxProvider } from 'react-scroll-parallax'
import App from './App'
import './index.css'
import { ThemeProvider } from './theme/ThemeProvider'
const container = document.getElementById('root')

const MEASUREMENT_ID = 'G-8DYBGKWC74'
ReactGA.initialize(MEASUREMENT_ID)

if (!container) {
  throw new Error('Root container element with id "root" not found')
}

createRoot(container).render(
  <ParallaxProvider>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </ParallaxProvider>
)
